<template>
  <!-- 表单容器 -->
  <div class="form-container">
    <!-- 表单 -->
    <div class="form" :style="formContainerStyle">
      <div class="base-tips">
        <img :src="fdaWarning" alt="" />
        <div>本人实名认证请填写本人信息，为家人实名认证请填写家人信息</div>
      </div>
      <div class="form-box">
        <div class="title">基本信息</div>
        <fda-field-picker v-model="form.relation" required name="relation" label="成员关系" :columns="RECORD_TYPES" />
        <fda-field v-model="form.fullName" required name="fullName" label="姓名" />
        <fda-field-picker v-model="form.gender" required name="gender" label="性别" :columns="GENDER_TYPES" />
        <fda-field-picker v-model="form.certType" required name="certType" label="证件类型" :columns="CARD_TYPES" />
        <fda-field v-model="form.certNo" name="certNo" required label="证件号码" />
      </div>
      <div class="form-box">
        <div class="title">审核信息</div>
        <van-field
          v-model="reviewOrgTxt"
          is-link
          readonly
          required
          label="审核机构"
          placeholder="选择机构"
          input-align="right"
          @click.stop="handleTapOrg"
        />
        <fda-field-picker
          v-model="form.reviewDoctor"
          required
          name="reviewDoctor"
          label="审核团队"
          :columns="VERIFY_OPTIONS"
        />
      </div>
      <div class="note">
        <img :src="shield" alt="" class="img-shield" />
        <div>
          根据国家法律法规规定，您授权本系统采集个人身份证信息，
          <br />
          我们将确保对本次采集到的信息履行相应的安全保障义务。
        </div>
      </div>
      <footer-btn ref="footerBtnRef">
        <van-cell
          :style="{
            paddingLeft: 0,
            paddingRight: 0,
            height: '10.93333vw',
            alignItems: 'center',
            fontSize: '3.73333vw',
          }"
          @click="toggle"
        >
          <template #title>
            <van-checkbox ref="checkboxRef" v-model="isChecked" icon-size="4.26667vw" @click.stop>
              确认已知晓
              <span :style="{ color: 'var(--fda-brand-color-500)' }" @click="goToAgreement">
                《个人信息处理授权意见》
              </span>
            </van-checkbox>
          </template>
        </van-cell>
        <van-button type="primary" :disabled="!authBtn" block @click="handleConfirm">提交</van-button>
      </footer-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import fdaWarning from '@/assets/images/fda-warning.png';
import { useConfigStore } from '@/store/modules/config';
import { router } from '@/router';
import { useRecordsStore } from '@/store/modules/records';
import shield from '@/assets/images/shield.png';
import { CheckboxInstance, showToast, showConfirmDialog } from 'vant';
import FooterBtn from '@/views/widget/FooterBtn.vue';
import { useMedicalOrgStore } from '@/store/modules/medicalOrg';
import { RecordVerifyTypeEnum } from '@tencent/fd-types';

const medicalOrgStore = useMedicalOrgStore();
const footerBtnRef = ref<any>(null);
const formContainerStyle = computed(() => {
  return {
    paddingBottom: `${footerBtnRef.value?.height ?? 0}px`,
  };
});

const isChecked = ref(false);

const form = reactive({
  fullName: '',
  relation: [1],
  gender: [1],
  certType: [1],
  certNo: '',
  reviewOrg: 0,
  reviewDoctor: [],
});
// 提交按钮状态4条件：关系 + 身份证照片 + 协议
const authBtn = computed(
  () => !!form.fullName && form.certNo && form.reviewOrg && form.reviewDoctor[0] && isChecked.value,
);
const reviewOrgTxt = ref('');
const configStore = useConfigStore();
const recordsStore = useRecordsStore();
const RECORD_TYPES = configStore.getDictItem('userRelation');
const GENDER_TYPES = configStore.getDictItem('gender');
const CARD_TYPES = configStore.getDictItem('certType');

const VERIFY_OPTIONS = ref<{ text: string; value: number; approvalDoctorId: string }[]>([]);

const handleTapOrg = (item) => {
  router.push({ name: 'manual-service' });
};
const goToAgreement = (e) => {
  e.stopPropagation();
  console.log('agree');
  router.push({
    name: 'agreement-page',
    query: {
      fileKey: 'personalAuthorization',
    },
  });
};
const checkboxRef = ref<CheckboxInstance | null>(null);
const toggle = () => {
  checkboxRef.value?.toggle();
};
const commit = async (manualVerifyBody) => {
  const res = await recordsStore.verify({
    type: RecordVerifyTypeEnum.manual,
    data: {
      manualVerifyBody,
    },
  });
  if (res) {
    showToast({
      message: '提交成功',
      type: 'success',
    });
    router.push({ name: 'manual-complete' });
  }
};
const handleConfirm = async () => {
  const groupInfo = VERIFY_OPTIONS.value.find((v) => v.value === form.reviewDoctor[0]);
  const manualVerifyBody = {
    relation: form.relation[0],
    name: form.fullName,
    gender: form.gender[0],
    certType: form.certType[0],
    certNo: form.certNo,
    reviewOrg: form.reviewOrg,
    reviewDoctor: groupInfo?.approvalDoctorId ?? '',
  };
  const check = await recordsStore.checkVerify(manualVerifyBody);
  if (check !== 1) {
    showConfirmDialog({
      title: '未找到档案信息',
      message: '您填写的证件号码可能有误或您暂未建档，请仔细核对！',
      confirmButtonText: '继续提交',
      cancelButtonText: '返回修改',
    })
      .then(() => {
        commit({ ...manualVerifyBody, isPass: check });
      })
      .catch(() => {
        // on cancel
      });
  } else {
    commit({ ...manualVerifyBody, isPass: check });
  }
};

const getOrgDoctorList = async () => {
  const res = await medicalOrgStore.fetchDoctorGroupList({ medicalOrgId: form.reviewOrg });

  VERIFY_OPTIONS.value =
    res?.map((item) => {
      return {
        text: item.title,
        value: item.groupId,
        approvalDoctorId: item.approvalDoctorId,
      };
    }) ?? [];
  form.reviewDoctor = [];
};

onActivated(() => {
  const { clear } = router.currentRoute.value.params;
  if (clear) {
    form.fullName = '';
    form.relation = [1];
    form.gender = [1];
    form.certType = [1];
    form.certNo = '';
  }
});

watch(
  () => recordsStore.getRecordsItem('org'),
  (val) => {
    if (val) {
      reviewOrgTxt.value = val.name;
      form.reviewOrg = val.id;
      getOrgDoctorList();
    }
  },
  { immediate: true },
);
</script>

<style scoped lang="less">
.form-container {
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 24px;

  .note {
    display: flex;
    padding: 6px 32px 0;
    line-height: 36px;
    font-weight: 400;
    font-size: 24px;
    color: var(--fda-gray-color-700);

    .img-shield {
      margin-right: 5px;
      width: 32px;
      height: 32px;
    }
  }

  .desc {
    padding: 24px 32px 30px;

    p {
      margin: 0 0 24px;
      line-height: 42px;
      text-align: justify;
      font-size: 28px;
      color: var(--fda-gray-color-700);
    }

    .idcard-rule {
      width: 648px;
      height: 143px;
    }
  }
}

.form {
  .base-tips {
    display: flex;
    padding: 16px 30px;

    img {
      margin-top: 18px;
      width: 32px;
      height: 32px;
    }

    div {
      margin-left: 30px;
      line-height: normal;
      text-align: justify;
      font-style: normal;
      font-weight: 400;
      font-size: 28px;
      color: #0d7cff;
    }
  }

  .form-box {
    margin-bottom: 24px;
    padding-top: 27px;
    width: 100%;
    background: #fff;
    text-align: center;

    .title {
      margin-bottom: 24px;
      padding-left: 32px;
      border-left: 10px solid #0d7cff;
      line-height: 48px; /* 150% */
      text-align: left;
      font-style: normal;
      font-weight: 500;
      font-size: 32px;
      letter-spacing: 2px;
    }

    :deep(.van-cell) {
      padding-top: 10px;
      padding-bottom: 10px;

      .van-cell__title {
        padding-left: 10px;
        text-align: left;
        font-weight: 400;
        font-size: 32px;
        color: var(--fda-gray-color-900);
      }

      .van-cell__value {
        font-weight: 400;
        font-size: 32px;
        color: var(--fda-brand-color-500);
      }

      .van-cell__right-icon {
        color: var(--fda-brand-color-500);
      }
    }

    .form-box-title {
      display: flex;
      padding-top: 32px;
      line-height: 48px;
      text-align: left;
      font-weight: 500;
      font-size: 32px;
      color: var(--fda-gray-color-900);

      .block {
        margin-right: 32px;
        width: 10px;
        height: 42px;
        background: var(--fda-brand-color-500);
      }
    }

    ul.remark {
      list-style: disc;
      margin-left: 42px;
      padding: 20px 32px;
      line-height: 42px;
      text-align: left;
      font-weight: 400;
      font-size: 28px;
      color: var(--fda-gray-color-500);

      li {
        line-height: 42px;
      }
    }
  }
}
</style>
